const FILE_TYPE_JSON = Symbol('JSON');
const MARKDOWN = Symbol('Markdown');
const XML = Symbol('XML');
const YAML = Symbol('YAML');
const PLAIN_TEXT = Symbol('Plain Text');

export const FileType = {
  JSON: FILE_TYPE_JSON,
  MARKDOWN,
  XML,
  YAML,
  PLAIN_TEXT,
};

export type FileType = (typeof FileType)[keyof typeof FileType];
